module.exports = __webpack_public_path__ + "static/media/fax.74875e99.svg";